import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';

const ContactsPage = lazy(() => import('./pages/ContactsPage'));

export const ROUTES = [
    {
        path: '/contacts',
        element: (
            <Suspense fallback={<Spinner block />}>
                <ContactsPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
